export default __webpack_public_path__ + "static/media/uiux1.48e0db76.jpg";